import CryptoJS from "crypto-js";


const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

export const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

export const formatActive = (value) => (value === '0' ? "Yes" : "No");




// 👇 add these
export const encryptId = (id) => {
    return CryptoJS.AES.encrypt(String(id), SECRET_KEY).toString();
};

export const decryptId = (hash) => {
    const bytes = CryptoJS.AES.decrypt(hash, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
};


